import React from 'react'

export const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="22" height="22" style={{marginBottom: '4px'}} >
            <path fill-rule="evenodd" d="M11.712 3.092a.5.5 0 0 1 .576 0l7.654 5.402A2.5 2.5 0 0 1 21 10.536V19.5a1.5 1.5 0 0 1-1.5 1.5H15a.5.5 0 0 1-.5-.5v-5A1.5 1.5 0 0 0 13 14h-2a1.5 1.5 0 0 0-1.5 1.5v5a.5.5 0 0 1-.5.5H4.5A1.5 1.5 0 0 1 3 19.5v-8.964a2.5 2.5 0 0 1 1.058-2.042zM12 4.112 4.635 9.311A1.5 1.5 0 0 0 4 10.536V19.5a.5.5 0 0 0 .5.5h4v-4.5A2.5 2.5 0 0 1 11 13h2a2.5 2.5 0 0 1 2.5 2.5V20h4a.5.5 0 0 0 .5-.5v-8.964a1.5 1.5 0 0 0-.635-1.225z" clip-rule="evenodd"></path>
        </svg>
    )
}